/* ============================================================
   PDP V2 — puente con el widget nativo de Judge.me

   La V2 dibuja su propio resumen (nota, histograma, resumen IA y las
   primeras 15 tarjetas) desde el metafield, y manda el widget nativo fuera
   de pantalla para no mostrar dos veces lo mismo.

   Pero toda ACCIÓN —ver el listado completo, escribir una reseña— la
   resuelve el widget real: se le devuelve al flujo y se acciona su propio
   control. Así la reseña entra por Judge.me, con su validación y moderación.

   Por qué fuera de pantalla y no display:none: Judge.me carga diferido, y
   con la sección en display:none nunca inicializaba su contenido.

   Archivo aparte de pdp-v2.js porque es la única pieza acoplada a un app de
   terceros: si cambian de app de reseñas, se toca solo esto.
   ============================================================ */
(function () {
  'use strict';

  /* El control de "escribir una reseña" del widget nuevo de Judge.me
     (`jdgm-widget-revamp`, clases `jm-`). El `.jdgm-write-rev-link` del widget
     clásico ya no existe en esta tienda. */
  var SEL_ESCRIBIR = '[data-testid="write-review-button"]';

  /* El listado completo se identifica por su id, NO por `.jdgm-widget`: esa
     clase la llevan dos nodos del documento, y el otro es el preview badge de
     la estrellita bajo el título, que vive en la sección `main` y aparece
     antes. Con `.jdgm-widget` el querySelector devolvía siempre el badge, así
     que revelábamos `main` en vez de la sección de reseñas. */
  function widget() {
    return document.getElementById('judgeme_product_reviews') ||
           document.querySelector('.jdgm-review-widget');
  }

  function seccionWidget() {
    var w = widget();
    return w ? w.closest('[id^="shopify-section-"]') : null;
  }

  function revelar() {
    var sec = seccionWidget();
    if (sec) sec.classList.add('v2-revelado');
    return sec;
  }

  function irA(el) {
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Acciona el control de Judge.me. Devuelve false si todavía no está montado. */
  function abrirFormulario() {
    var w = widget();
    var btn = w && w.querySelector(SEL_ESCRIBIR);
    if (!btn) return false;
    btn.click();
    return true;
  }

  document.addEventListener('click', function (e) {

    /* ---- Ver todas las reseñas ---- */
    if (e.target.closest('[data-v2-rev-todas]')) {
      e.preventDefault();
      irA(revelar());
      return;
    }

    /* ---- Escribir una reseña ----
       Se acciona el botón propio de Judge.me en vez de montar un formulario
       nuestro. Ese botón abre un modal que se monta en <body> con
       position:fixed y z-index alto, así que acá NO se revela la sección: el
       modal se ve igual con el widget fuera de pantalla, y al cerrarlo el
       usuario no queda mirando el listado duplicado.

       Judge.me monta el widget de forma diferida, así que si el control aún no
       existe se reintenta un rato. Si nunca aparece, se cae a revelar el
       listado para que el usuario llegue igual a la UI del app. */
    if (e.target.closest('[data-v2-rev-escribir]')) {
      e.preventDefault();
      if (abrirFormulario()) return;

      var intentos = 0;
      var reloj = setInterval(function () {
        if (abrirFormulario()) { clearInterval(reloj); return; }
        if (++intentos > 20) { clearInterval(reloj); irA(revelar()); }
      }, 250);
    }
  });

})();
